module.exports = __webpack_public_path__ + "3b91477f96a24a09510632d46c1fd8a3.svg";